// Import package components
import { useMemo, useEffect, useContext, useState, useRef } from "react";

// Import base components
import { Image } from "uikit-react";
import { AppContexts } from "../../../providers";

const Responses = ({ onChange }) => {
  const {
    templatesCtx: { get, templates },
  } = useContext(AppContexts.TemplatesContext);

  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  const responses = useMemo(() => {
    if (Object.keys(templates).length === 0) return [];
    if (!templates.saved_responses) return [];
    return templates.saved_responses
      .slice()
      .sort((prev, next) => prev.name.localeCompare(next.name));
  }, [templates]);

  const filteredResponses = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return responses;

    return responses.filter((r) => {
      const name = (r.name || "").toLowerCase();
      const body = (r.response || "").toLowerCase();
      return name.includes(q) || body.includes(q);
    });
  }, [responses, query]);

  useEffect(() => {
    get(["saved_responses"]);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = () => {
    setOpen((prev) => {
      if (!prev && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        setOpenUpward(spaceBelow < 370);
      }
      return !prev;
    });
  };

  const handleSelect = (response) => {
    onChange(response);
    setOpen(false);
  };

  return (
    <div ref={containerRef} style={{ position: "relative", zIndex: 1010 }}>
      <button
        uk-tooltip="Click to select from a Saved Response"
        type="button"
        onClick={handleToggle}
      >
        <Image src="/images/reply-with.svg" className="msg-icon" />
      </button>

      {open && (
        <div
          id="messages-response"
          className="uk-dropdown uk-open"
          style={{
            minWidth: 360,
            maxHeight: 350,
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            ...(openUpward
              ? { bottom: "100%", marginBottom: 6 }
              : { top: "100%", marginTop: 6 }),
            left: 0,
            zIndex: 1000,
          }}
        >
          <div className="macros-search-wrapper">
            <input
              ref={inputRef}
              className="uk-input uk-form-small macros-search-input"
              style={{ width: "100%" }}
              type="text"
              placeholder="Search saved responses..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>

          <ul
            className="uk-nav uk-dropdown-nav tags-selector"
            style={{ overflowY: "auto", flex: 1, padding: "0 4px 6px", margin: 0 }}
          >
            {filteredResponses.length > 0 ? (
              filteredResponses.map((response, index) => (
                <li
                  key={response.id ?? `${response.name}-${index}`}
                  className="messages-li"
                  style={{
                    display: "block",
                    borderBottom: "1px solid #e5e5e5",
                    borderRadius: 0,
                    cursor: "pointer",
                    padding: "10px 12px",
                  }}
                  uk-tooltip="Click to Insert"
                  onClick={() => handleSelect(response.response)}
                >
                  <div className="semi-bold-font">{response.name}</div>
                  <div
                    style={{
                      color: "#888",
                      fontSize: 13,
                      marginTop: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {response.response}
                  </div>
                </li>
              ))
            ) : responses.length > 0 ? (
              <div style={{ padding: "20px 25px" }}>
                No matches for "{query}".
              </div>
            ) : (
              <div style={{ padding: "30px 25px" }}>
                No saved responses. <a href="/saved-responses">Add Now.</a>
              </div>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Responses;
